import { render, staticRenderFns } from "./q9.vue?vue&type=template&id=401c858c&scoped=true"
import script from "./q9.vue?vue&type=script&lang=js"
export * from "./q9.vue?vue&type=script&lang=js"
import style0 from "./q9.vue?vue&type=style&index=0&id=401c858c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "401c858c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\new-tis\\FR-TISSOT-IFB-Discovery-SFCC\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('401c858c')) {
      api.createRecord('401c858c', component.options)
    } else {
      api.reload('401c858c', component.options)
    }
    module.hot.accept("./q9.vue?vue&type=template&id=401c858c&scoped=true", function () {
      api.rerender('401c858c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "cartridges/int_guidedProductFinder/cartridge/client/default/js/components/questionTemplates/q9.vue"
export default component.exports